/**
 * Created by prog2 on 26/10/2018.
 */
export default {
    images: [

        {
            id: 60,
            img: require('./../assets/img/art/60.jpg'),
            imageMenu: require('../assets/img/menu/thumb_60.jpg'),

        },
        {
            id: 61,
            img: require('./../assets/img/art/61.jpg'),
            imageMenu: require('../assets/img/menu/thumb_61.jpg'),

        },
        {
            id: 1,
            img: require('./../assets/img/art/1.jpg'),
            imageMenu: require('../assets/img/menu/thumb_1.jpg'),

        },
        {
            id: 2,
            img: require('./../assets/img/art/2.jpg'),
            imageMenu: require('./../assets/img/menu/thumb_2.jpg'),
        },
        {
            id: 3,
            img: require('./../assets/img/art/3.jpg'),
            imageMenu: require('./../assets/img/menu/thumb_3.jpg'),
        },
        {
            id: 4,
            imageMenu: require('./../assets/img/menu/thumb_4.jpg'),
            img: require('./../assets/img/art/4.jpg'),
        },
        {
            id: 5,
            imageMenu: require('./../assets/img/menu/thumb_5.jpg'),
            img: require('./../assets/img/art/5.jpg'),
        },
        {
            id: 6,
            imageMenu: require('./../assets/img/menu/thumb_6.jpg'),
            img: require('./../assets/img/art/6.jpg'),
        },
        {
            id: 7,
            imageMenu: require('./../assets/img/menu/thumb_7.jpg'),
            img: require('./../assets/img/art/7.jpg'),
        },
        {
            id: 8,
            imageMenu: require('./../assets/img/menu/thumb_8.jpg'),
            img: require('./../assets/img/art/8.jpg'),
        },
        {
            id: 9,
            imageMenu: require('./../assets/img/menu/thumb_9.jpg'),
            img: require('./../assets/img/art/9.jpg'),
        },
        {
            id: 10,
            imageMenu: require('./../assets/img/menu/thumb_10.jpg'),
            img: require('./../assets/img/art/10.jpg'),
        },
        {
            id: 11,
            imageMenu: require('./../assets/img/menu/thumb_11.jpg'),
            img: require('./../assets/img/art/11.jpg'),
        },
        {
            id: 12,
            imageMenu: require('./../assets/img/menu/thumb_12.jpg'),
            img: require('./../assets/img/art/12.jpg'),
        },
        {
            id: 13,
            imageMenu: require('./../assets/img/menu/thumb_13.jpg'),
            img: require('./../assets/img/art/13.jpg'),
        },
        {
            id: 14,
            imageMenu: require('./../assets/img/menu/thumb_14.jpg'),
            img: require('./../assets/img/art/14.jpg'),
        },
        {
            id: 15,
            imageMenu: require('./../assets/img/menu/thumb_15.jpg'),
            img: require('./../assets/img/art/15.jpg'),
        },
        {
            id: 16,
            imageMenu: require('./../assets/img/menu/thumb_16.jpg'),
            img: require('./../assets/img/art/16.jpg'),
        },
        {
            id: 17,
            imageMenu: require('./../assets/img/menu/thumb_17.jpg'),
            img: require('./../assets/img/art/17.jpg'),
        },
        {
            id: 18,
            imageMenu: require('./../assets/img/menu/thumb_18.jpg'),
            img: require('./../assets/img/art/18.jpg'),
        },
        {
            id: 19,
            imageMenu: require('./../assets/img/menu/thumb_19.jpg'),
            img: require('./../assets/img/art/19.jpg'),
        },
        {
            id: 20,
            imageMenu: require('./../assets/img/menu/thumb_20.jpg'),
            img: require('./../assets/img/art/20.jpg'),
        },
        {
            id: 21,
            imageMenu: require('./../assets/img/menu/thumb_21.jpg'),
            img: require('./../assets/img/art/21.jpg'),
        },
        {
            id: 22,
            imageMenu: null,
            img: require('./../assets/img/art/22.png'),
        },


    ]
}


// WEBPACK FOOTER //
// ./src/data/images.js